// src/components/AdvancedMode/AdvancedMode.js

import React, { useEffect, useState, useCallback } from 'react';
import { Box, Slider, Checkbox, Typography } from '@mui/material';
import PasswordDisplay from '../PasswordDisplay/PasswordDisplay';
import { generatePassword, calculateEntropy, estimateTimeToCrack } from '../../utils/passwordUtils';

const AdvancedMode = () => {
  const [settings, setSettings] = useState({
    length: 16,
    useUppercase: true,
    useLowercase: true,
    useDigits: true,
    useSpecial: true,
  });
  const [passwordData, setPasswordData] = useState(null);

  const generateCustomPassword = useCallback(() => {
    const password = generatePassword({ length: settings.length, useLowercase: true, ...settings }); // Ensure lowercase is always included
    const entropy = calculateEntropy(password);
    const timeToCrack = estimateTimeToCrack(entropy);

    setPasswordData({ password, entropy, timeToCrack });
  }, [settings]); // Dependencies for memoisation (if it uses state/props, add them here)

  useEffect(() => {
    generateCustomPassword();
  }, [generateCustomPassword]); // Safely include the memoised function
 

  return (
    <Box sx={{ textAlign: 'center', marginTop: '2rem' }}>
      <Typography variant="h5" sx={{ marginBottom: '1rem' }}>
      How many characters do you need?
      </Typography>
      <Slider
        value={settings.length}
        onChange={(e, newValue) => setSettings((prev) => ({ ...prev, length: newValue }))}
        min={4}
        max={64}
        valueLabelDisplay="auto"
        sx={{ marginBottom: '1rem' }}
      />
      <PasswordDisplay {...passwordData} onRegenerate={generateCustomPassword} />
      <Box sx={{ marginTop: '1rem', padding: '1rem', borderTop: '1px solid #ddd' }}>
        {['useUppercase', 'useDigits', 'useSpecial'].map((key) => (
          <Typography key={key} sx={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
            <Checkbox
              checked={settings[key]}
              onChange={() => setSettings((prev) => ({ ...prev, [key]: !prev[key] }))}
              sx={{ marginRight: '0.5rem' }}
            />
            {key === 'useUppercase'
              ? 'Capital Letters (ABC)'
              : key === 'useLowercase'
              ? 'Lowercase Letters (abc)'
              : key === 'useDigits'
              ? 'Numbers (123)'
              : 'Special Characters (!@#)'}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default AdvancedMode;
